import { HttpClient } from "@/App/services";
import { UtcHelper } from "./../store/Utc.helper";

export interface CasesRequest {
  numberOfDaysToGetCases?: any;
  emsAgencyId: String;
  fromDate?: String;
  toDate?: String;
}

export const dateXDaysAgo = (days: number): string => {
  return new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString().split("T")[0];
};

export default {
  getCases: ({
    numberOfDaysToGetCases,
    emsAgencyId,
    fromDate = dateXDaysAgo(numberOfDaysToGetCases),
    toDate = undefined
  }: CasesRequest): Promise<Array<any>> => {
    let params = `emsAgency=${emsAgencyId}&createdFrom=${UtcHelper.formatInitialDate({ date: fromDate })}`;
    if (toDate) {
      params += `&createdTo=${toDate}`;
    }
    return HttpClient.get({
      path: `/twiageCases?${params}`
    }).then(({ data }) => data);
  }
};
